import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;

  .paywall__content {
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex-direction: column;
    padding: 48px;
    box-sizing: border-box;

    overflow-y: auto;
    overflow-x: hidden;


    .header__buttons {
      display: flex;
      gap: 10px;
      margin-bottom: 30px;

      button {
        border: none;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
        border-radius: 25px;
        max-width: 175px;
        /* width: 100%; */
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        color: white;
        cursor: pointer;

        gap: 5px;
        transition: filter 0.2s;

        box-shadow: 0 9px 12px rgba(0, 0, 0, 0.3);

        svg {
          height: 14px;
        }

        &.gray {
          background-color: #4E4E4E;
        }

        &.purple {
          background-color: var(--purple-500);
        }

        &:hover {
          filter: brightness(0.9);
        }
      }
    }

    .content__first-box {
      color: white;
      display: grid;
      grid-template-rows: 50px auto 50px;
      height: 100%;

      .plans-page__title {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 10px;
        margin-top: 42px;
      }

      .plans-page__subtitle {
        font-size: 18px;
        margin-bottom: 30px;
        font-weight: 300;

        b {
          font-weight: 700;
        }
      }
    }
  }
  

  
  .planCardsContainerHeader {
    display: flex;
  }
  
  .planCardsContainerHeader__giftCardButton {
    box-shadow: 0 9px 12px rgba(0, 0, 0, 0.3);
    background-color: #8774ff;
    width: 50%;
    padding: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    border: none;
    border-radius: 25px;
    margin: 0;
    color: white;
    transition: linear 0.2s;
    margin-top: 21px;
    &:hover {
      cursor: pointer;
      filter: brightness(0.9);
    }
  }
  
  .getBackToContent__button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    box-shadow: 0 9px 12px rgba(0, 0, 0, 0.3);
    background-color: var(--green-base);
    width: 50%;
    padding: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    border: none;
    border-radius: 25px;
    margin: 21px 0;
    color: white;
    transition: linear 0.2s;
    &:hover {
      cursor: pointer;
      filter: brightness(0.9);
    }
  }
  .planCardsContainerHeader__title {
    color: white;
    font-size: 2rem;
    margin-top: 15px;
    font-weight: 700;
    br {
      display: none;
    }
  }
  .plansCardsContainerHeader__subtitle {
    color: white;
    font-size: 1rem;
    font-weight: 300;
    text-align: center;
    margin-bottom: 1rem;
    max-width: 680px;
    align-self: center;
    display: flex;
    line-height: 1.5rem;
  }

  .planCardsContainerContent {
    gap: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
  }


  .download-apps__container {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 20px;
    position: fixed;
    right: 20px;
    bottom: 50px;

    a:not(.whatsapp_icon) {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #080808;
      border: 1px solid #fff;
      border-radius: 5px;
      height: 48px;
      max-width: 147px;
    }
    img {
      width: 100%;
    }
  }

  .giftCard__button {
    background-color: var(--purple-500);

    margin-top: 40px;
    height: 40px;
    border-radius: 25px;
    border: none;
    text-transform: uppercase;
    color: white;
    font-weight: 700;
  }

  .giftCardSection {
    background-color: #1E1E1E;
    padding: 20px;
    border: 1px solid white;
    border-radius: 10px;
  }

  .giftCardSection__sendButton {
    margin-top: 10px;
    background-color: #7515ED;
    border: none;
    border-radius: 25px;
    height: 32px;
    color: white;
    padding: 0 20px;
    float: right;

    &:disabled {
      filter: brightness(0.5);
      cursor: not-allowed;
    }
  }

  .footer__text {
    font-size: 10px;
    text-align: center;
    font-weight: 300;

    b {
      font-weight: 700;
    }
  }



  .title {
    font-size: 1.25rem;
    color: white;
    font-weight: 700;
  }

  .price__container {
    display: flex;
    align-items: flex-end;
    width: 100%;
    margin: 1.5rem 0;
    
    .price {
      color: ${({priceHasChanged}) => priceHasChanged ? 'var(--yellow-500)' : 'white'};
      font-size: 2.5rem;
      font-weight: bold;
      margin-right: 1rem;
    }

    .price__description {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      color: #fff;
      font-size: 0.75rem;
      line-height: 1rem;
      font-family: Source Sans Pro;
      font-weight: 400;
    }
  }

  .subscript__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;

    button {
      max-width: 100%;
      width: auto;
      padding: 0 3.5rem;
      height: 40px;
    }
  }

  @media screen and (max-width: 717px) {
    .subscript__container {
      margin-top: 0;
      button {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 1010px) {
    .paywall__content {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr auto;
      gap: 40px;
      padding: 70px 20px 20px;
      overflow-y: auto;
      overflow-x: hidden;

      .header__buttons {
        position: absolute;
        top: 20px;
        width: 100%;
      }

      .content__first-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }

    .giftCardSection__sendButton {
      width: 100%;
      margin-bottom: 20px;
      height: 40px;
    }

    .download-apps__container {
      justify-content: center;
      position: initial;
    }
  }
`;
